/* src/modules/interviews/components/ConfirmationPopup/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  return {
    card: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: unit * 75,
      transform: 'translate(-50%, -50%)',
      overflow: 'auto',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: unit,
    },
    content: {
      padding: unit * 3,
    },
    subtitle: {
      marginBottom: unit * 2,
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/components/ConfirmationPopup/styles.js